import React from 'react';
import AdminAlertsPanel from '../components/AdminAlertsPanel';

export default function AdminBorrowerAlerts() {
  return <AdminAlertsPanel category="borrower" title="Borrower Alerts" subtitle="Borrower activity requiring your attention" />;
}
